module.exports = __webpack_public_path__ + "static/media/dotted_background.afd549c0.png";